// extracted by mini-css-extract-plugin
module.exports =  {"bannerContainer":"bannerContainer__XqzZF","content":"content__i7lEB"};